// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button-containerr {
  display: flex;
  /* align-items: flex-end; */
  margin-top: 50px;
  justify-content: right;
  /* margin-right: 100px; */
  /* margin-left: 1000px; */
  /* background-color: white; */
  width: 100%;
  height: 50px;
}

.upbutto {
  margin-left: 10px;
  margin-top: 10px;
  margin-right: 60px;
  padding: 10px 20px;
  background-image: linear-gradient(to top, rgb(227, 226, 226), white);
  color: black;
  cursor: pointer;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  height: 30px;
  display: flex;
  align-items: center;
  border-radius: 6px;
  border: 1px solid lightgray;
}

.upbutto a {
  color: black;
  text-decoration: none;
}

.upbutton a {
  color: black;
  text-decoration: none;
}

.upbutto:hover {
  background-image: linear-gradient(to top, lightgrey, white);
}

.upbutton:hover {
  background-image: linear-gradient(to top, lightgrey, white);
}

.upbutton {
  margin-left: 10px;
  margin-top: 10px;
  margin-right: 10px;
  padding: 10px 20px;
  background-image: linear-gradient(to top, rgb(227, 226, 226), white);
  color: black;
  cursor: pointer;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  height: 30px;
  display: flex;
  align-items: center;
  border-radius: 6px;
  border: 1px solid lightgray;
}

.history-text {
  margin-top: 100px;
  font-size: 25px;
  margin-left: 95px;
}

.arrow {
  font-size: 20px;
  color: black;
}

/* h2 {
  margin-left: 30px;
} */

.progBar {
  z-index: 1000;
}

.paragraph {
  font-size: 15px;
  margin: 0px;
  text-align: center;
}

.pa-box {
  border: 1px solid #f4f7ff;
  width: 80px;
  background-color: #f4f7ff;
  margin-left: 30px;
  margin-top: 30px;
  align-items: center;
  justify-content: center;
}

.history {
  margin-left: 80px;
}

.a-box {
  /* background-color: #8b9ab9; */
  width: 30px;
  border-radius: 80px;
  color: white;
  align-items: center;
  text-align: center;
  max-height: 26px;
  margin-top: 30px;
}

.vertical-line {
  border-left: 2px solid #e1e6ec;
  height: 120px;
  margin-left: 10px;
}

.ua {
  margin-left: 0px;
}

.t-box {
  width: 85%;
  height: 65vh;
  max-height: 65vh;
  overflow-y: auto;
  border: 1px solid lightgray;
  margin-left: 100px;
  margin-top: 30px;
  box-shadow: 0 0 10px rgba(0, 136, 255, 0.5);
  background-color: rgb(255, 255, 255);
}
.p {
  color: black;
}

.list-item {
  list-style: none;
  display: block;
  text-decoration: none;
}

.conte {
  margin-left: 30px;
}

.history {
  margin-left: 60px;
}
`, "",{"version":3,"sources":["webpack://./src/Css/Timeline.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,2BAA2B;EAC3B,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;EACzB,6BAA6B;EAC7B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,oEAAoE;EACpE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,oEAAoE;EACpE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;;GAEG;;AAEH;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;EAC3C,oCAAoC;AACtC;AACA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".button-containerr {\r\n  display: flex;\r\n  /* align-items: flex-end; */\r\n  margin-top: 50px;\r\n  justify-content: right;\r\n  /* margin-right: 100px; */\r\n  /* margin-left: 1000px; */\r\n  /* background-color: white; */\r\n  width: 100%;\r\n  height: 50px;\r\n}\r\n\r\n.upbutto {\r\n  margin-left: 10px;\r\n  margin-top: 10px;\r\n  margin-right: 60px;\r\n  padding: 10px 20px;\r\n  background-image: linear-gradient(to top, rgb(227, 226, 226), white);\r\n  color: black;\r\n  cursor: pointer;\r\n  text-align: center;\r\n  text-decoration: none;\r\n  display: inline-block;\r\n  font-size: 16px;\r\n  height: 30px;\r\n  display: flex;\r\n  align-items: center;\r\n  border-radius: 6px;\r\n  border: 1px solid lightgray;\r\n}\r\n\r\n.upbutto a {\r\n  color: black;\r\n  text-decoration: none;\r\n}\r\n\r\n.upbutton a {\r\n  color: black;\r\n  text-decoration: none;\r\n}\r\n\r\n.upbutto:hover {\r\n  background-image: linear-gradient(to top, lightgrey, white);\r\n}\r\n\r\n.upbutton:hover {\r\n  background-image: linear-gradient(to top, lightgrey, white);\r\n}\r\n\r\n.upbutton {\r\n  margin-left: 10px;\r\n  margin-top: 10px;\r\n  margin-right: 10px;\r\n  padding: 10px 20px;\r\n  background-image: linear-gradient(to top, rgb(227, 226, 226), white);\r\n  color: black;\r\n  cursor: pointer;\r\n  text-align: center;\r\n  text-decoration: none;\r\n  display: inline-block;\r\n  font-size: 16px;\r\n  height: 30px;\r\n  display: flex;\r\n  align-items: center;\r\n  border-radius: 6px;\r\n  border: 1px solid lightgray;\r\n}\r\n\r\n.history-text {\r\n  margin-top: 100px;\r\n  font-size: 25px;\r\n  margin-left: 95px;\r\n}\r\n\r\n.arrow {\r\n  font-size: 20px;\r\n  color: black;\r\n}\r\n\r\n/* h2 {\r\n  margin-left: 30px;\r\n} */\r\n\r\n.progBar {\r\n  z-index: 1000;\r\n}\r\n\r\n.paragraph {\r\n  font-size: 15px;\r\n  margin: 0px;\r\n  text-align: center;\r\n}\r\n\r\n.pa-box {\r\n  border: 1px solid #f4f7ff;\r\n  width: 80px;\r\n  background-color: #f4f7ff;\r\n  margin-left: 30px;\r\n  margin-top: 30px;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.history {\r\n  margin-left: 80px;\r\n}\r\n\r\n.a-box {\r\n  /* background-color: #8b9ab9; */\r\n  width: 30px;\r\n  border-radius: 80px;\r\n  color: white;\r\n  align-items: center;\r\n  text-align: center;\r\n  max-height: 26px;\r\n  margin-top: 30px;\r\n}\r\n\r\n.vertical-line {\r\n  border-left: 2px solid #e1e6ec;\r\n  height: 120px;\r\n  margin-left: 10px;\r\n}\r\n\r\n.ua {\r\n  margin-left: 0px;\r\n}\r\n\r\n.t-box {\r\n  width: 85%;\r\n  height: 65vh;\r\n  max-height: 65vh;\r\n  overflow-y: auto;\r\n  border: 1px solid lightgray;\r\n  margin-left: 100px;\r\n  margin-top: 30px;\r\n  box-shadow: 0 0 10px rgba(0, 136, 255, 0.5);\r\n  background-color: rgb(255, 255, 255);\r\n}\r\n.p {\r\n  color: black;\r\n}\r\n\r\n.list-item {\r\n  list-style: none;\r\n  display: block;\r\n  text-decoration: none;\r\n}\r\n\r\n.conte {\r\n  margin-left: 30px;\r\n}\r\n\r\n.history {\r\n  margin-left: 60px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
